<template>
  <section>
    <b-row class="mt-2">
      <b-col class="custom-access-title">
        New Access Request for {{ userDetails.firstName }} {{ userDetails.lastName }}
      </b-col>
    </b-row>
    <hr class="solid py-1" />
    <person-details></person-details>
  </section>
</template>

<script>
  import PersonDetails from '../PersonDetails';
  import { mapGetters } from 'vuex';
  export default {
    name: 'custom-access-header',
    components: {
      PersonDetails,
    },
    computed: {
      ...mapGetters(['userDetails']),
    },
  };
</script>

<style>
  .custom-access-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
  }
</style>
